export function product(...arrays) {
    if (arrays.length === 0) {
        return [];
    }
    const [firstArray, ...restArray] = arrays;
    const combinations = restArray.length > 0 ? product(...restArray) : [[]];
    const result = [];
    for (const element of firstArray) {
        result.push(...combinations.map(combination => [element, ...combination]));
    }
    return result;
}
